<mat-card class="cardWithShadow" style="padding: 36px 36px 0px 36px">
  <mat-card-content
    *ngIf="isLoading"
    class="d-flex flex-col flex-wrap align-items-center justify-content-center"
    style="padding-bottom: 36px"
  >
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    <p>Cargando insumos del Almacén (SKUs)...</p>
  </mat-card-content>

  <mat-card-content
    class="d-flex flex-row flex-wrap gap-20 align-items-center justify-content-center"
    *ngIf="!isLoading"
  >
    <mat-card-title> Agregar Insumos al Plato </mat-card-title>
    <form [formGroup]="insumoForm">
      <div style="display: flex; flex-wrap: wrap; gap: 30px">
        <mat-form-field appearance="outline" style="width: 20rem">
          <mat-label>Insumo</mat-label>
          <input
            matInput
            type="text"
            placeholder="Elige un Insumo"
            [formControl]="searchControl"
            [matAutocomplete]="auto"
            required
          />
          <mat-autocomplete
            #auto="matAutocomplete"
            [displayWith]="getOptionText"
            (optionSelected)="updateInsumoUnidadMedida($event)"
          >
            <mat-option disabled *ngIf="isLoadingInsumosFromDish$ | async">
              <div
                style="
                  display: flex;
                  align-items: center;
                  gap: 8px;
                  padding: 8px;
                "
              >
                <mat-progress-spinner
                  mode="indeterminate"
                ></mat-progress-spinner>
                <span>Cargando insumos...</span>
              </div>
            </mat-option>
            <ng-container *ngIf="!(isLoadingInsumosFromDish$ | async)">
              <mat-option
                disabled
                *ngIf="(filteredOptionsWithValidation$ | async)?.length === 0"
              >
                No se encontraron insumos
              </mat-option>
              <mat-option
                *ngFor="let item of filteredOptionsWithValidation$ | async"
                [value]="item.option"
                [disabled]="item.isDuplicate"
              >
                <div *ngIf="!item.isDuplicate">
                  {{ item.option.nombreInsumo }}
                </div>
                <div *ngIf="item.isDuplicate" style="font-style: italic">
                  Este ingrediente ya existe en el Plato:
                  {{ item.option.nombreInsumo }}
                </div>
              </mat-option>
            </ng-container>
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Cantidad</mat-label>
          <input
            matInput
            placeholder="Cantidad"
            formControlName="cantidad"
            name="cantidad"
            required
            type="number"
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Unidad de Medida</mat-label>
          <input
            matInput
            placeholder="Unidad de Medida"
            formControlName="unidadMedida"
            name="unidad de medida"
            required
            readonly
          />
        </mat-form-field>
      </div>
    </form>

    <div style="padding-bottom: 30px">
      <button
        mat-mini-fab
        style="background-color: #e95a1a"
        (click)="addInsumo()"
      >
        <mat-icon style="color: white">add</mat-icon>
      </button>
    </div>
  </mat-card-content>

  <mat-card-content
    [style.display]="addedInsumos.length > 0 ? 'block' : 'none'"
    style="padding: 36px"
  >
    <div class="table-responsive">
      <mat-table mat-table matSort [dataSource]="dataSource">
        <ng-container matColumnDef="nombreInsumo">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Nombre
          </mat-header-cell>
          <mat-cell *matCellDef="let sku">
            {{ sku.nombreInsumo }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="cantidad">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Cantidad
          </mat-header-cell>
          <mat-cell *matCellDef="let sku">
            {{ sku.cantidad }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="unidadMedida">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Unidad de Medida
          </mat-header-cell>
          <mat-cell *matCellDef="let sku">
            {{ sku.unidadMedida }}
          </mat-cell>
        </ng-container>

        <mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
    </div>

    <mat-dialog-actions *ngIf="!isLoading" align="center">
      <button mat-button mat-dialog-close>Cancelar</button>
      <button mat-raised-button color="primary" (click)="updatePlato()">
        Guardar Insumos
      </button>
    </mat-dialog-actions>
  </mat-card-content>
</mat-card>
